export const GLOBAL_STATE = 'Attendance'

export const ATTENDANCE = 'attendance'
export const ATTENDANCE_GROUP = 'attendanceGroup'
export const ATTENDANCE_CSV = 'attendanceCSV'
export const ATTENDANCE_TABLE = 'attendanceTable'
export const ATTENDANCE_TABLE_STUDENT = 'attendanceTableStudent'
export const ATTENDANCE_TABLE_MODULE = 'attendanceTableModule'
export const ATTENDANCE_QR_CODE = 'attendanceQRCode'
